import { useEffect, useRef, useState } from "react";
import { LuGift, LuUpload } from "react-icons/lu";
import { useFreeTokensModal } from "../../../providers/FreeTokensModalProvider";
import {
  DashboardMode,
  useDashboardControlsActions,
  useDashboardMode,
  WorkspaceSection,
} from "../../../view_stores/useDashboardControlsStore";
import {
  PreviewMode,
  useProjectPreviewMode,
} from "../../../view_stores/useProjectPreviewStore";
import { ProjectPreviewScreenshotControls } from "../../projectPreview/components/ProjectPreviewScreenshotControls";
import { ProjectDashboardModeSwitch } from "./ProjectDashboardModeSwitch";

export default function ProjectDashboardTopPanel({
  isDisabled,
}: {
  isDisabled: boolean;
}) {
  const dashboardMode = useDashboardMode();
  const previewMode = useProjectPreviewMode();

  const { show: showFreeTokensModal } = useFreeTokensModal();
  const { setDashboardMode, setWorkspaceSection } =
    useDashboardControlsActions();

  const containerRef = useRef<HTMLDivElement>(null);

  const [canShowFreeTokensLabel, setCanShowFreeTokensLabel] = useState(true);

  function onPublishClick() {
    setDashboardMode(DashboardMode.WORKSPACE);
    setWorkspaceSection(WorkspaceSection.PUBLISH);
  }

  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setCanShowFreeTokensLabel(entry.contentRect.width > 400);
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
      setCanShowFreeTokensLabel(true);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex items-center justify-between gap-4 p-4 
          border-b-2 border-white/50 dark:border-[#373B40] 
          relative"
    >
      <div className="flex-1 flex items-center gap-2">
        <ProjectDashboardModeSwitch isDisabled={isDisabled} />
        {dashboardMode === DashboardMode.PREVIEW &&
          previewMode === PreviewMode.Desktop && (
            <ProjectPreviewScreenshotControls optionsPosition="bottom-center" />
          )}
      </div>
      <div className="flex items-center gap-4">
        <button
          className={`flex items-center justify-center
              gap-2 rounded-full z-50
              transition-colors bg-primary-blue text-white hover:bg-blue-400
              ${
                canShowFreeTokensLabel ? "py-2 px-4 w-fit" : "h-[40px] w-[40px]"
              }`}
          onClick={() => {
            showFreeTokensModal();
          }}
        >
          <LuGift size={16} />
          {canShowFreeTokensLabel && "Free tokens"}
        </button>
        <button
          onClick={onPublishClick}
          disabled={isDisabled}
          className="flex items-center justify-center 
                gap-2 w-fit py-2 px-4 rounded-full 
                transition-colors bg-primary-blue text-white hover:bg-blue-400"
        >
          <LuUpload size={16} />
          <span>Publish</span>
        </button>
      </div>
    </div>
  );
}
